export const theme = {
  default: {
    primary: "#6e3667",
    secondary: "#f4f1f3",
    textOnPrimary: "#FFF",
    textOnSecondary: "#000",
  },
}
